var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 196.763,
    viewBox: "0 0 1920 196.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wave_down",
    d: "M0,151.513l64,12.666c64,12.192,192,38.233,320,31.486,128-6.274,256-44.152,384-82.03s256-75.756,384-56.817,256,94.7,384,107.361c128,12.192,256-37.523,320-63.209l64-25.213V0H0Z",
    fill: "#061136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveDown);
export default __webpack_public_path__ + "static/media/wave_down.6556e2bf244e95ce65e26fa251ccb2eb.svg";
export { ForwardRef as ReactComponent };